import React, { useState, useEffect } from "react";
import axios from 'axios';



import GlobalStyle from "../../../styles/global3.js";
import "react-toastify/dist/ReactToastify.css";
import styled from "styled-components";
import PainelBotoes from './components/Painel.js';
import { toast, ToastContainer } from "react-toastify";

import logo1 from "../../../styles/imagem/logo-1.png";
import logo2 from "../../../styles/imagem/logo-2.png";
import logo3 from "../../../styles/imagem/logo-3.png";
import logo4 from "../../../styles/imagem/logo-4.png";
import logo5 from "../../../styles/imagem/logo-5.png";



const Geral = styled.div`
  height: 100vh;
  overflow-y: auto;

  @media (max-width: 1024px) {
    width: 98vw;
    display: flex;
    justify-content: center;
    height: auto;
    margin-top: 50px; // Reduced from 150px
  }
`;
const Imagem = styled.img`
  width: 600px;
  height: auto;

  @media (max-width: 768px) {
    width: 200px;
    height: auto;
  }
`;





function App() {

  //-----------------------------------------------------------------------//
  //Ip's da api e do front

  const urlFront = process.env.REACT_APP_FRONT_URL;
  const urlApi = process.env.REACT_APP_API_URL;


  //Token da api
  const token = localStorage.getItem('token');
  const id = localStorage.getItem('id');

  //---------------------------VERIFICA O TOKEN------------------------------------------//

  //Verifica o token do usuário
  useEffect(() => {
    const getToken = async () => {
      try {
        const res = await axios.get(`${urlApi}logon/token`, { headers: { Authorization: `Bearer ${token}` } });
      } catch (error) {
        if (error.response && (error.response.status === 400 || error.response.status === 403 || error.response.status === 401)) {
          window.location.href = `${urlFront}login`;
        } else {
          console.error("Erro ao obter token:", error);
        }
      }
    };

    getToken();
  }, [token]);


  //--------------------------RECEBE OS ACESSOS DO USUÀRIO-------------------------------------//

  //Get que retorna os dados que usuário pode acessar no portal
  const [acessos, setAcessos] = useState([]);

  useEffect(() => {
    const fetchAcessos = async () => {
      try {
        const res = await axios.post(`${urlApi}portal/acessos-portal`,
          { id },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setAcessos(res.data);
      } catch (error) {
        console.error('Erro ao buscar dados de acessos:', error);
      }
    };

    fetchAcessos();
  }, [token]);




  //---------------------IMAGEM DE CARREGANDO-----------//
  const [abaAtiva, setAbaAtiva] = useState("");
  const [loadingImage, setLoadingImage] = useState(null);

  const imagens = [logo1, logo2, logo3, logo4, logo5];

  const trocarAbaComImagem = (novaAba) => {
    const imagemAleatoria = imagens[Math.floor(Math.random() * imagens.length)];
    setLoadingImage(imagemAleatoria);

    setTimeout(() => {
      setLoadingImage(null);
      setAbaAtiva(novaAba);
    }, 1000);
  };

  useEffect(() => {
    trocarAbaComImagem("painel"); // define o nome da aba ativa
  }, []);

  //----------------------------------------------------//

  return (
    <>
      <Geral>
        {loadingImage || abaAtiva === "" ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100vh",
              width: "100%",
              textAlign: "center",
            }}
          >
            <Imagem
              src={loadingImage}
              alt="Carregando..."
              style={{
                animation: "zoomIn 0.8s ease-out forwards"
              }}
            />
            <style>
              {`
              @keyframes zoomIn {
                from {
                  opacity: 0;
                  transform: scale(0.8);
                }
                to {
                  opacity: 1;
                  transform: scale(1);
                }
              }
            `}
            </style>
          </div>
        ) : (
          <PainelBotoes urlApi={urlApi} acessos={acessos} />
        )}
        <GlobalStyle />


      </Geral >

      <ToastContainer
        autoClose={2500}
        position={toast.POSITION.BOTTOM_LEFT}
        style={{ width: '400px', fontSize: '22px' }}
      />
    </>
  );

}

export default App;
